<template>
  <div class="">
    <!-- 工序 -->
    <template v-for="(item, index) in processProblem" :key="index">
      <h2 class="statistics">
        {{ props.year }}年{{ getProcessName(item.process) }}工序不合格记录
      </h2>

      <template
        v-for="(unQualifiedList, unQualifiedIndex) in item.data"
        :key="unQualifiedIndex"
      >
        <div class="df">
          <table border="1" class="type-table">
            <tr>
              <th rowspan="2"></th>
            </tr>
            <tr></tr>
            <tr>
              <th>物料导致</th>
            </tr>
            <tr>
              <th>人为导致</th>
            </tr>
            <tr>
              <th>半成品</th>
            </tr>
            <tr>
              <th>软件导致</th>
            </tr>
            <tr>
              <th>其他</th>
            </tr>
          </table>

          <template
            v-for="(unQualified, unQualifiedIndex) in unQualifiedList"
            :key="unQualifiedIndex"
          >
            <table border="1" class="rate-table">
              <tr>
                <th colspan="2">{{ unQualified.month }} 月</th>
              </tr>
              <tr>
                <th>数量</th>
                <th>环比</th>
              </tr>

              <template v-for="(type, typeIndex) in reasonKey" :key="typeIndex">
                <tr>
                  <td>
                    {{
                      unQualified[type]
                        ? unQualified[type].anomalyNumber == 0
                          ? ""
                          : unQualified[type].anomalyNumber
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      unQualified[type]
                        ? unQualified[type].qoq == 0
                          ? ""
                          : `${unQualified[type].qoq}%`
                        : ""
                    }}
                  </td>
                </tr>
              </template>
            </table>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import {
  PQCProductOption,
  getProcessName,
} from "@/views/productDaily/serve/option";

import { useTDArray } from "@/views/productionInstruction/server";

export default defineComponent({
  props: {
    unQualifiedData: Object,
    year: String,
  },
  setup(props, context) {
    // 工序问题明细
    const processProblem = reactive([]);

    const tableWidth = 240;
    const typTableWidth = 374;
    const availableWidth = window.screen.width - 40 - typTableWidth;

    const unqualifiedRow = Math.floor(availableWidth / tableWidth);

    const setMonthProblem = () => {
      const list = [];

      for (let i = 1; i <= 12; i += 1) {
        list.push({
          month: i,
          物料导致: {
            anomalyNumber: 0,
            qoq: 0,
          },
          人为导致: {
            anomalyNumber: 0,
            qoq: 0,
          },
          半成品: {
            anomalyNumber: 0,
            qoq: 0,
          },
          软件导致: {
            anomalyNumber: 0,
            qoq: 0,
          },
          其他: {
            anomalyNumber: 0,
            qoq: 0,
          },
        });
      }

      return list;
    };

    // 默认设置工序
    const initProcess = () => {
      processProblem.length = 0;
      PQCProductOption.filter((f) => f.label !== '包装').forEach((item) => {
        const list = setMonthProblem();

        processProblem.push({
          process: item.value,
          data: list,
        });
      });

      console.log(processProblem);
    };

    const reasonKey = ["物料导致", "人为导致", "半成品", "软件导致", "其他"];

    const setProcessProblemData = (data) => {
      console.log(data, 'data');
      Object.keys(data).forEach((process) => {
        // 工序下标
        const processIndex = PQCProductOption.findIndex(
          (f) => f.value === process
        );

        if (processIndex === -1) return;

        const processData = data[process];

        Object.keys(processData).forEach((reason) => {
          const reasonData = processData[reason];

          Object.keys(reasonData).forEach((month) => {
            const { anomalyNumber, qoq } = reasonData[month];

            const target = processProblem[processIndex].data.find(
              (f) => f.month == month
            );
            console.log(target, processIndex, "error");
            if (target[reason]) {
              target[reason].anomalyNumber = anomalyNumber;
              target[reason].qoq = qoq;
            }
          });
        });
      });

      const tdArray = (list) => {
        const tdList = [];

        const count = Math.ceil(list.length / unqualifiedRow);

        for (let i = 1; i <= count; i += 1) {
          const start = (i - 1) * unqualifiedRow;
          const end = i * unqualifiedRow;
          tdList.push(list.slice(start, end));
        }

        return tdList;
      };

      processProblem.forEach((item) => {
        item.data = tdArray(item.data);
      });
    };

    // 设置不合格数据月
    watch(
      () => props.unQualifiedData,
      (val) => {
        initProcess();
        if (val) {
          setProcessProblemData(val);
        } else {
          processProblem.forEach((item) => {
            item.data = useTDArray(
              {
                windowWidth: window.screen.width - 40,
                broadsideWidth: typTableWidth,
                tablewidth: tableWidth,
                maxCount: unqualifiedRow,
              },
              item.data
            );
          });
        }
      },
      {
        immediate: true,
      }
    );

    return {
      props,
      reasonKey,
      processProblem,
      getProcessName,
    };
  },
});
</script>

<style lang="less" scoped>
.rate-table {
  border-left: none;
  margin-bottom: 20px;
}
.rate-table > tr > th {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}

.type-table {
  margin-bottom: 20px;
}

.type-table > tr > th {
  width: 120px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  text-align: center;
  background: #e0e0e0;
}

.type-table > tr:nth-child(1) > th {
  height: 95px;
}
</style>
